const styles = theme => ({
  card: {
    display: 'flex',
    maxWidth: 400,
    alignItems: 'center',
    textAlign: 'center',
  },
  masterCard: {
    marginBottom: 18,
    width: 'calc(100% - 12px)',
    height: 24,
    maxWidth: 480,
    alignItems: 'center',
    textAlign: 'center',
  },
  text: {
    alignItems: 'center',
    textAlign: 'center',
    paddingTop: 1,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/Home/scenes/RapidDisplayView/components/PopulationCount/styles.js